var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ChatForm from "./ChatForm";
import { postReq } from "../request";
import ConversationItem from "./ConversationItem";
import Emoji from "./Emoji";
import FileUpload from "./FileUpload";
import { MessageByTypeEnum, MessageFormatType, ChatSessionConnectedWithEnum, AIBotPromptActionEnum, } from "../Models";
import { getFormData, getFormMetaData, getOperatorFromSession, isGPTEnabled, pushMessage, uuidv4, } from "../Utils";
import { AppContext } from "../appContext";
import { CONNECT_TO_AGENT_URL_PATH, FORM_DATA, MESSAGE_URL_PATH, NEW_SESSION_URL_PATH, OPENED_CHAT, PARENT_WINDOW, PROACTIVE_MESSAGE, TYPING_ALERT_URL_PATH, } from "../globals";
import { useContext, useEffect, useState, useRef, } from "react";
import { getLocalStoragePrefs, getSessionStoragePrefs, removeSessionStoragePrefs, setLocalStoragePrefs, setSessionStoragePrefs, } from "../Storage";
import CloseWidgetPanel from "./CloseWidgetPanel";
import InteractiveFlowItem from "./InteractiveFlowItem";
var Conversation = function (props) {
    var _a;
    var parentContext = useContext(AppContext);
    var chatPrefs = parentContext.chatPrefs, sessions = parentContext.sessions, setSessions = parentContext.setSessions;
    var text = useRef(null);
    var _b = useState([]), formFields = _b[0], setFormFields = _b[1];
    var _c = useState(""), typeText = _c[0], setTypeText = _c[1];
    var _d = useState([]), files = _d[0], setFiles = _d[1];
    var _e = useState(false), showChatForm = _e[0], setShowChatForm = _e[1];
    var _f = useState(), typingTimer = _f[0], setTypingTimer = _f[1];
    var _g = useState(false), saving = _g[0], setSaving = _g[1];
    var _h = useState(new Set()), fileData = _h[0], setFileData = _h[1];
    var pasteFiles = function (e, items, noFile) {
        var files = [];
        if (!noFile) {
            var _loop_1 = function (item) {
                if (item.kind.indexOf("string") == -1) {
                    var blob_1 = item.getAsFile();
                    files.push(blob_1);
                    var reader = new FileReader();
                    // Capture the current selection range
                    var selection = window.getSelection();
                    if (!selection || !selection.rangeCount)
                        return "continue";
                    var range = selection.getRangeAt(0).cloneRange();
                    reader.onload = function (elem) {
                        var _a, _b, _c;
                        (_a = document.querySelector(".img-wrapper")) === null || _a === void 0 ? void 0 : _a.remove();
                        (_b = document.querySelector(".doc-wrapper")) === null || _b === void 0 ? void 0 : _b.remove();
                        var wrapper = document.createElement("div");
                        if ([
                            ".png",
                            ".jpg",
                            ".jpeg",
                            ".gif",
                            ".bmp",
                            ".svg",
                            ".ico",
                            ".jfif",
                            ".webp",
                            ".jpe",
                        ].some(function (ext) { return blob_1.name.endsWith(ext); })) {
                            wrapper.className = "img-wrapper";
                            var img = document.createElement("img");
                            img.className = "img-content";
                            img.src = (_c = elem === null || elem === void 0 ? void 0 : elem.target) === null || _c === void 0 ? void 0 : _c.result;
                            wrapper.appendChild(img);
                        }
                        else {
                            console.log("doc ...");
                            wrapper.className = "doc-wrapper";
                            var subWrapper = document.createElement("div");
                            subWrapper.className = "doc-element";
                            subWrapper.innerHTML =
                                '<svg id="Icons" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg"><path d="m20.828 9.917-7.984 7.983a4.93 4.93 0 0 1 -6.807.273 4.766 4.766 0 0 1 -.1-6.843l6.8-6.8a2.845 2.845 0 0 1 4.023 4.023l-6.8 6.8a.944.944 0 0 1 -1.3 0 .925.925 0 0 1 0-1.3l5.437-5.437a1 1 0 0 0 -1.424-1.416l-5.437 5.435a2.927 2.927 0 0 0 0 4.133 2.992 2.992 0 0 0 4.132 0l6.8-6.8a4.845 4.845 0 1 0 -6.855-6.848l-6.8 6.8a6.765 6.765 0 0 0 .148 9.713 6.607 6.607 0 0 0 4.562 1.767 7.122 7.122 0 0 0 5.035-2.087l7.984-7.984a1 1 0 1 0 -1.414-1.414z"></path></svg>';
                            var nameSpan = document.createElement("span");
                            nameSpan.className = "mx-2";
                            nameSpan.textContent = blob_1.name;
                            subWrapper.appendChild(nameSpan);
                            wrapper.appendChild(subWrapper);
                        }
                        var closeBtn = document.createElement("span");
                        closeBtn.className = "img-close";
                        closeBtn.innerHTML = "&times;";
                        closeBtn.onclick = function () {
                            wrapper.remove();
                            setFileData(function (prev) {
                                var newSet = new Set(prev);
                                newSet.delete(blob_1);
                                return newSet;
                            });
                        };
                        wrapper.appendChild(closeBtn);
                        // Insert the image *after* the editable div
                        var inputBox = document.getElementById("chatMessageEditable");
                        if (inputBox) {
                            inputBox.insertAdjacentElement("afterend", wrapper);
                            scrollInput();
                        }
                    };
                    reader.readAsDataURL(blob_1);
                    // prevent default paste
                    e.preventDefault();
                }
                return "break";
            };
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                var state_1 = _loop_1(item);
                if (state_1 === "break")
                    break;
            }
        }
        setFileData(function (prev) { return new Set(__spreadArray(__spreadArray([], prev, true), files, true)); });
    };
    var getEmptySession = function () {
        var session = {};
        session.message_list = [];
        var initialMessage = getSessionStoragePrefs(PROACTIVE_MESSAGE);
        if (chatPrefs.matchedBotPrefs &&
            chatPrefs.matchedBotPrefs.id &&
            chatPrefs.matchedBotPrefs.settings.welcomeMessage) {
            session.message_list.push({
                from: MessageByTypeEnum.GPT,
                message: chatPrefs.matchedBotPrefs.settings.welcomeMessage,
                message_type: MessageFormatType.TEXT,
                session_id: undefined,
                created_time: new Date().getTime() / 1000,
            });
        }
        else if (initialMessage) {
            session.message_list.push({
                from: MessageByTypeEnum.System,
                message: initialMessage,
                message_type: MessageFormatType.TEXT,
                session_id: undefined,
                system_message_type: "PROACTIVE_SYSTEM_MESSAGE",
                created_time: new Date().getTime() / 1000,
            });
        }
        return session;
    };
    var getSession = function () {
        var chatId = getSessionStoragePrefs(OPENED_CHAT);
        if (!chatId || chatId == "new") {
            return getEmptySession();
        }
        var matchedSession = sessions.find(function (session) {
            return session.id == chatId;
        });
        console.log("matchedSession", matchedSession);
        if (matchedSession)
            return matchedSession;
        return getEmptySession();
    };
    var _j = useState(getSession()), session = _j[0], setSession = _j[1];
    var _k = useState(undefined), matchedBotPrefs = _k[0], setMatchedBotPrefs = _k[1];
    useEffect(function () {
        setScrollBottom();
    }, [session === null || session === void 0 ? void 0 : session.message_list]);
    useEffect(function () {
        if (session.connected_with == ChatSessionConnectedWithEnum.AGENT)
            setMatchedBotPrefs(undefined);
    }, [session === null || session === void 0 ? void 0 : session.connected_with]);
    useEffect(function () {
        setSession(getSession());
    }, [sessions]);
    useEffect(function () {
        var chatId = getSessionStoragePrefs(OPENED_CHAT);
        if ((!session ||
            !(session === null || session === void 0 ? void 0 : session.message_list) ||
            (session === null || session === void 0 ? void 0 : session.message_list.length) === 0) &&
            shouldShowForm() &&
            !isGPTEnabled() &&
            (!chatId || chatId == "new")) {
            setShowChatForm(true);
        }
        var matchedBot = getMatchedBotPrefs();
        if (matchedBot) {
            setMatchedBotPrefs(matchedBot);
        }
    }, []);
    var getMatchedBotPrefs = function () {
        var _a;
        if (session && session.id) {
            if (!session.gpt_bot_id ||
                session.connected_with != ChatSessionConnectedWithEnum.GPT)
                return undefined;
            return (_a = chatPrefs.botPrefs) === null || _a === void 0 ? void 0 : _a.find(function (pref) {
                if (pref.id == (session === null || session === void 0 ? void 0 : session.gpt_bot_id))
                    return pref;
            });
        }
        return chatPrefs.matchedBotPrefs;
    };
    useEffect(function () {
        var storedFormData = {};
        try {
            var obj = getFormData();
            if (obj)
                storedFormData = JSON.parse(obj);
        }
        catch (error) { }
        var fields = [];
        chatPrefs.prechat.formData.forEach(function (field, index) {
            var fieldClone = JSON.parse(JSON.stringify(field));
            fieldClone.value =
                storedFormData[fieldClone.name] &&
                    !(field.field_type == "SYSTEM" && field.name == "message")
                    ? storedFormData[fieldClone.name]
                    : "";
            if (fieldClone.type == "multicheckbox" || fieldClone.type == "checkbox")
                fieldClone.valueArr = storedFormData[fieldClone.name]
                    ? Array.from(storedFormData[fieldClone.name])
                    : [];
            fieldClone.is_valid = false;
            fields.push(fieldClone);
        });
        setFormFields(fields);
    }, [showChatForm]);
    var publishMessageToChatAgents = function (message) {
        if (!session)
            return;
        // Holding for a moment to make changes live
        // with PUSHER service
        // if (true) return;
        // Check for invalid Session/Agents
        //if (!session || !pusher) return;
        var ids = session.participant_user_ids;
        if (!ids || !ids.length)
            return;
        var json = {
            event_type: "TYPING",
            message: {
                from: "VISITOR",
                message: message,
                session_id: session.id,
                agent_ids: session.participant_user_ids,
            },
        };
        /*for (var i = 0; i < ids.length; i++) {
          that.ortcClient.send(ids[i] + '', JSON.stringify(json));
        }*/
        // Send an event via server
        var wait = postReq(TYPING_ALERT_URL_PATH, json);
        wait
            .then(function (response) {
            console.log("typing");
        })
            .catch(function () { });
    };
    var updateMessage = function (message) {
        if (!message.session_id) {
            return;
        }
        // Get session from session id
        var session = getSessionById(message.session_id);
        console.log("updating message session", session);
        if (!session || !session.message_list || session.message_list.length == 0)
            return;
        session.message_list.map(function (eachmessage) {
            if (message.id === eachmessage.id)
                return message;
            return eachmessage;
        });
        setSessions(__spreadArray([], sessions, true));
    };
    // const updateSession = () => {
    //   setSessions([...sessions]);
    // }
    var getSessionById = function (id) {
        if (!id)
            return undefined;
        return sessions.find(function (session) {
            return session.id === Number(id);
        });
    };
    var disableType = function () {
        var _a, _b;
        return session.connected_with == ChatSessionConnectedWithEnum.GPT &&
            (((_a = session.message_list[session.message_list.length - 1]) === null || _a === void 0 ? void 0 : _a.message_type) ==
                "FETCHING" ||
                ((_b = session.message_list[session.message_list.length - 1]) === null || _b === void 0 ? void 0 : _b.status))
            ? true
            : false;
    };
    var updateMessageList = function (message) {
        if (!message.session_id) {
            return;
        }
        // Get session from session id
        var session = getSessionById(message.session_id);
        console.log("updating message session", session);
        if (!session)
            return;
        var i = session.message_list
            .map(function (message) { return message.id; })
            .indexOf(message.id); // find index of your object
        session.message_list.splice(i, 1, message); // remove it from array
        setSessions(__spreadArray([], sessions, true));
    };
    var onEmojiSelect = function (emoji) {
        if (text.current) {
            var current_1 = text.current;
            var curPos_1 = current_1.selectionStart;
            var value = current_1.value;
            current_1.textContent =
                value.slice(0, curPos_1) + emoji + value.slice(curPos_1);
            setTypeText(current_1.textContent);
            setTimeout(function () {
                current_1.selectionStart = current_1.selectionEnd = curPos_1 + emoji.length;
            }, 0);
            text.current.focus();
        }
    };
    var handleScroll = function (e) {
        if (e.currentTarget.classList.contains("on_scroll") === false) {
            var el = e.currentTarget;
            e.currentTarget.classList.add("on_scroll");
            setTimeout(function () {
                el.classList.remove("on_scroll");
            }, 1000);
        }
    };
    var submitChatForm = function (formData) {
        if (!formData)
            formData = {};
        setShowChatForm(false);
        var prevFormData = getLocalStoragePrefs(FORM_DATA);
        if (prevFormData) {
            prevFormData = JSON.parse(prevFormData);
            Object.assign(prevFormData, formData);
        }
        else {
            prevFormData = formData;
        }
        setLocalStoragePrefs(FORM_DATA, JSON.stringify(prevFormData));
        sendMessage(true);
        // Submit form
        // setEnableChatFooter(true);
        // Regular flow
        // connectToAgent();
    };
    var fileUploadCallback = function (status, file) {
        if (status == "success") {
            sendFileUploadMessage(file);
        }
        else {
            var mssg = file.error_mssg ||
                "Whoops! Something went wrong. Please try again later.";
            var data = getChatMessage(mssg, undefined);
            data.from = MessageByTypeEnum.System;
            pushMessage(data, session);
            setSessions(__spreadArray([], sessions, true));
        }
    };
    /**
     * Send uploaded file
     */
    var sendFileUploadMessage = function (file) {
        if (!file)
            return;
        // Message as JSON for file upload
        var message = {};
        message.fileName = file.name;
        message.fileUrl = file.bucketURL + file.file_resource;
        message.fileSize = file.size;
        message.fileType = file.type;
        // Send message
        postMessage(getChatMessage(JSON.stringify(message), MessageFormatType.FILE));
    };
    var updateAndOpenSession = function (newNession) {
        console.log("updating session", newNession);
        props.addNewSession(newNession);
        setTimeout(function () {
            // TODO
            // props.openChat(newNession.id);
            setSaving(false);
        }, 1000);
    };
    var submitSessionEvent = function (url, data, callback) {
        var isNewChat = !session || !session.id ? true : false;
        // Add browser info + local storage data
        if (isNewChat) {
            var metaData = getFormMetaData();
            try {
                var client_info = PARENT_WINDOW.EngHub_Storage.read_cookie(PARENT_WINDOW.EngHub_Storage.client_info_key, true);
                if (client_info)
                    metaData.client_info = client_info;
            }
            catch (error) { }
            data.meta_data = JSON.stringify(metaData);
        }
        // Send connected bot id in every request
        if (matchedBotPrefs)
            data.gpt_bot_id = matchedBotPrefs.id;
        var wait = postReq(url, data);
        wait
            .then(function (response) {
            console.log(response);
            if (callback)
                callback(response);
        })
            .catch(function () { });
    };
    var postMessage = function (data) {
        if (!session)
            return;
        //
        var newChat = true;
        if (session && session.id)
            newChat = false;
        // Set status sending
        data.status = "SENDING";
        setSaving(true);
        data.created_time = parseInt((new Date().getTime() / 1000).toString());
        data.id = uuidv4();
        try {
            // data.wa_visitor_id = window.parent.EhAPI.getWAVisitorId();
        }
        catch (err) {
            JSON.stringify({});
        }
        var url = newChat ? NEW_SESSION_URL_PATH : MESSAGE_URL_PATH;
        // Make temp push
        if (newChat) {
            pushMessage(data, session);
        }
        else {
            data.session_id = session === null || session === void 0 ? void 0 : session.id;
            pushMessage(data, session);
        }
        // Add gpt id in each request, So that can keep ai connection alive with visitor
        if (matchedBotPrefs === null || matchedBotPrefs === void 0 ? void 0 : matchedBotPrefs.id) {
            session.gpt_bot_id = matchedBotPrefs === null || matchedBotPrefs === void 0 ? void 0 : matchedBotPrefs.id;
            data.gpt_bot_id = matchedBotPrefs === null || matchedBotPrefs === void 0 ? void 0 : matchedBotPrefs.id;
        }
        submitSessionEvent(url, newChat ? session : data, function (response) {
            if (newChat) {
                // Get session
                var newNession = response.data;
                updateAndOpenSession(newNession);
                setSession(newNession);
                setSessionStoragePrefs(OPENED_CHAT, newNession.id);
            }
            else {
                updateMessageList(response.data);
            }
        });
    };
    var getChatMessage = function (msg, type) {
        var state = {
            from: MessageByTypeEnum.Visitor,
            message: msg,
            message_type: !type ? MessageFormatType.TEXT : type,
            session_id: session === null || session === void 0 ? void 0 : session.id,
            created_time: new Date().getTime(),
        };
        // Add session id if present
        if (session && session.id && session.type == "LIVECHAT")
            state.session_id = session.id;
        return state;
    };
    // const agent = getOperatorFromSession(props.session, parentContext.agents);
    var handleKeyPress = function (e) {
        // console.log(e.currentTarget.textContent);
        if (e.currentTarget.textContent != null)
            setTypeText(e.currentTarget.textContent);
        else
            setTypeText("");
    };
    var handleKeyDown = function (e) {
        if (e.key === "Enter") {
            if (fileData.size) {
                setFiles(Array.from(fileData));
                setFileData(new Set());
                var pastedImages = document.querySelectorAll(".img-wrapper");
                pastedImages.forEach(function (img) { return img.remove(); });
                var pastedDocs = document.querySelectorAll(".doc-wrapper");
                pastedDocs.forEach(function (doc) { return doc.remove(); });
            }
            e.preventDefault();
            sendMessage(false);
        }
    };
    var setScrollBottom = function () {
        // setTimeout(() => {
        var elem = document.getElementsByClassName("chat__messages-track")[0];
        if (elem)
            elem.scrollTop = elem.scrollHeight;
        // }, 100);
    };
    var scrollInput = function () {
        var elem = document.getElementsByClassName("chat__form")[0];
        if (elem)
            elem.scrollTop = elem.scrollHeight;
    };
    // Send typing alert
    var userTyping = function () {
        if (!typeText.trim()) {
            return;
        }
        console.log("send alert1", typeText);
        publishMessageToChatAgents(typeText);
    };
    var shouldShowForm = function () {
        return parentContext.chatPrefs.prechat.enabled;
    };
    /**
     * Send typed message
     */
    var sendMessage = function (check) {
        if ((!session || !session.id) && shouldShowForm() && !check && typeText) {
            setShowChatForm(true);
            return;
        }
        var triggerFromProactive = getSessionStoragePrefs(PROACTIVE_MESSAGE);
        removeSessionStoragePrefs(PROACTIVE_MESSAGE);
        if (!typeText && !triggerFromProactive)
            return;
        // this.deleteStoragePrefs('FORM_SUBMIT');
        var message = typeText.trim();
        if (!message) {
            message = triggerFromProactive;
        }
        //that = this;
        setTypeText("");
        // Clear content holder
        if (text.current) {
            text.current.textContent = "";
        }
        // Stop typing timer
        //  userUnFocused();
        // Send message and make empty
        postMessage(getChatMessage(message, undefined));
        setScrollBottom();
    };
    var getHeaderIcon = function () {
        var agent = getOperatorFromSession(session, parentContext.agents);
        if (agent && (agent === null || agent === void 0 ? void 0 : agent.profile_img_url))
            return agent === null || agent === void 0 ? void 0 : agent.profile_img_url;
        if (matchedBotPrefs === null || matchedBotPrefs === void 0 ? void 0 : matchedBotPrefs.id)
            return matchedBotPrefs === null || matchedBotPrefs === void 0 ? void 0 : matchedBotPrefs.settings.chatBotIconURL;
        return parentContext.chatPrefs.widget.default_profile_image;
    };
    var getHeaderName = function () {
        var agent = getOperatorFromSession(session, parentContext.agents);
        if (agent && (agent === null || agent === void 0 ? void 0 : agent.name))
            return agent === null || agent === void 0 ? void 0 : agent.name;
        if (matchedBotPrefs === null || matchedBotPrefs === void 0 ? void 0 : matchedBotPrefs.id)
            return matchedBotPrefs === null || matchedBotPrefs === void 0 ? void 0 : matchedBotPrefs.name;
        return parentContext.chatPrefs.widget.title;
    };
    var connectToAgent = function () {
        var url = session && session.id
            ? CONNECT_TO_AGENT_URL_PATH + session.id
            : NEW_SESSION_URL_PATH;
        // session
        session.connect_to_agent_on_demand = true;
        var formData = getFormMetaData();
        session.meta_data = JSON.stringify(formData);
        if (formData && formData.message) {
            session.message_list.push(getChatMessage(formData.message, MessageFormatType.TEXT));
        }
        submitSessionEvent(url, session, function (response) {
            // Get session
            var newNession = response.data;
            // newNession.message_list = session.message_list;
            setMatchedBotPrefs(undefined);
            updateAndOpenSession(newNession);
        });
    };
    var _l = useState(null), clickTimeout = _l[0], setClickTimeout = _l[1];
    var executeBotPromptAction = function (prompt) {
        if (disableType())
            return;
        if (clickTimeout)
            return;
        else {
            var timeout = setTimeout(function () {
                setClickTimeout(null);
            }, 700); // Delay to detect if double-click happens
            setClickTimeout(timeout);
        }
        switch (prompt.action) {
            case AIBotPromptActionEnum.CONNECT_TO_AGENT:
                // if (matchedBotPrefs?.settings.showChatFormBeforeConnectToAgent) {
                //   setShowChatForm(true);
                //   return;
                // }
                // Connect to agent
                connectToAgent();
                break;
            case AIBotPromptActionEnum.MESSAGE:
                var message = getChatMessage(prompt.message, MessageFormatType.TEXT);
                message.from = MessageByTypeEnum.Visitor;
                console.log("in", message);
                if ((!session || !session.id) && shouldShowForm()) {
                    setTypeText(message.message);
                    setShowChatForm(true);
                    return;
                }
                // Push message
                // props.pushMessage(message);
                postMessage(getChatMessage(message.message, undefined));
                setScrollBottom();
                break;
            default:
                break;
        }
    };
    var getChatPrompts = function () {
        var _a;
        if (!matchedBotPrefs ||
            ((_a = matchedBotPrefs.botPrompts) === null || _a === void 0 ? void 0 : _a.length) == 0 ||
            (!matchedBotPrefs.botPrompts.find(function (prompt) { return prompt.action == AIBotPromptActionEnum.MESSAGE; }) &&
                !session.id))
            return _jsx(_Fragment, {});
        return (_jsx("div", __assign({ className: "chat_prompts_actions" }, { children: matchedBotPrefs.botPrompts.map(function (prompt) {
                return (prompt.action == AIBotPromptActionEnum.CONNECT_TO_AGENT &&
                    session.id) ||
                    prompt.action == AIBotPromptActionEnum.MESSAGE ? (_jsx("button", __assign({ className: "btn btn-outline-primary", onClick: function () { return executeBotPromptAction(prompt); } }, { children: prompt.label }))) : (_jsx(_Fragment, {}));
            }) })));
    };
    var goBack = function () {
        if (session.unRead) {
            session.unRead = 0;
            setSessions(__spreadArray([], sessions, true));
        }
        props.showChatsList();
    };
    return (_jsxs("div", __assign({ className: "chat__conversation" }, { children: [_jsxs("div", __assign({ className: "chat__header" }, { children: [_jsxs("div", __assign({ className: "chat__header-action" }, { children: [_jsx("div", __assign({ "data-trigger": "all", className: "chat__header-back", onClick: function () { return goBack(); } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", color: "currentColor" }, { children: _jsx("path", { stroke: "#fff", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.7", d: "m14 18-6-6 6-6" }) })) })), _jsxs("div", __assign({ className: "chat__header-user" }, { children: [_jsx("div", { children: _jsx("div", { className: "chat__header-user-img", style: { backgroundImage: 'url("' + getHeaderIcon() + '")' } }) }), _jsx("div", __assign({ className: "chat__header-user-title" }, { children: _jsxs("h1", __assign({ className: "chat__header-user-name" }, { children: [" ", getHeaderName(), " "] })) }))] }))] })), _jsx("div", __assign({ className: "chat__help-end" }, { children: _jsx(CloseWidgetPanel, {}) }))] })), _jsxs("div", __assign({ className: "chat__content" }, { children: [_jsxs("div", __assign({ className: "chat__messages" }, { children: [_jsx("div", __assign({ className: "chat__messages-track" }, { children: _jsxs("div", { children: [!showChatForm ? ((_a = session === null || session === void 0 ? void 0 : session.message_list) === null || _a === void 0 ? void 0 : _a.map(function (message, index) {
                                            return (_jsx(_Fragment, { children: message.system_message_type ==
                                                    MessageFormatType.FLOW_NODE && message.meta_data ? (_jsx(InteractiveFlowItem, { execution: JSON.parse(message.meta_data).executionNode })) : (_jsx(ConversationItem, { message: message, session: session, nextMessage: session === null || session === void 0 ? void 0 : session.message_list[index + 1], formFields: formFields, updateMessage: updateMessage })) }));
                                        })) : (_jsx(_Fragment, {})), showChatForm ? (_jsx(ChatForm, { closeChatForm: function () {
                                                setShowChatForm(false);
                                            }, formFields: formFields, setFormFields: setFormFields, submitChatForm: submitChatForm, typeText: typeText, setTypeText: setTypeText, saving: saving })) : (_jsx(_Fragment, {}))] }) })), _jsx("div", __assign({ className: "chat__messages-sign hide" }, { children: _jsxs("a", __assign({ target: "_blank" }, { children: ["We", _jsx("img", { src: "https://d2p078bqz5urf7.cloudfront.net/cloud/assets/livechat/love-icon.svg", width: "12px" }), "EngageBay"] })) }))] })), !showChatForm && getChatPrompts(), _jsx("div", __assign({ className: "chat__footer ".concat(showChatForm ? "hide" : "") }, { children: _jsxs("div", __assign({ className: "chat__form", style: {
                                paddingRight: session &&
                                    session.connected_with === ChatSessionConnectedWithEnum.AGENT
                                    ? "110px"
                                    : "90px",
                            } }, { children: [_jsx("textarea", { ref: text, rows: 1, onChange: function (e) { return setTypeText(e.currentTarget.value); }, onScroll: function (e) { return handleScroll(e); }, className: "chat__input chat__textarea", value: typeText, placeholder: !matchedBotPrefs
                                        ? parentContext.chatPrefs.widget.welcome_message_placeholder
                                        : matchedBotPrefs.settings.placeHolderText, contentEditable: "true", onPaste: function (e) {
                                        var _a;
                                        // e.preventDefault();
                                        var items = ((_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.items) || [];
                                        if (session &&
                                            session.connected_with === ChatSessionConnectedWithEnum.AGENT)
                                            pasteFiles(e, items, false);
                                        else
                                            pasteFiles(e, items, true);
                                        // document.execCommand(
                                        //   "insertHTML",
                                        //   false,
                                        //   e.clipboardData.getData("text/plain")
                                        // );
                                    }, onKeyDown: handleKeyDown, disabled: disableType(), onInput: function (e) { return handleKeyPress(e); }, onKeyUp: userTyping, id: "chatMessageEditable" }), _jsxs("div", __assign({ className: "chat__actions" }, { children: [_jsx(Emoji, { onEmojiSelect: onEmojiSelect }), session &&
                                            session.connected_with === ChatSessionConnectedWithEnum.AGENT ? (_jsx(FileUpload, { fileUploadCallback: fileUploadCallback, files: files, setFiles: setFiles })) : (_jsx(_Fragment, {})), typeText ? (_jsx("button", __assign({ className: "chat__btn chat_send_btn", onClick: function () { return sendMessage(false); } }, { children: _jsx("svg", __assign({ width: "16", height: "16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.394 14.7L13.75 9.3c1-.577 1-2.02 0-2.598L4.394 1.299a1.5 1.5 0 00-2.25 1.3v3.438l4.059 1.088c.494.132.494.833 0 .966l-4.06 1.087v4.224a1.5 1.5 0 002.25 1.299z" }) })) }))) : (_jsx(_Fragment, {}))] }))] })) }))] }))] })));
};
export default Conversation;
